// extracted by mini-css-extract-plugin
export default {"wiggle":"styles_wiggle__H553v","flash":"styles_flash__wDHTo","toolbarButtonContainer":"styles_toolbarButtonContainer__Z0Gn4","toolbarButtonImage":"styles_toolbarButtonImage__gJqhD"};